import React, { useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import * as dataSelectors from '@/data/data-selectors';
import * as mapActions from '@/map/map-actions';
import * as mapSelectors from '@/map/map-selectors';
import * as userSelectors from '@/user/user-selectors';

import { CardFilterPopover } from './card-filter-popover';
import * as header from './card-viewer-header-styles';
import { IconButtonWithTitle } from './header-icon-button';
import { SortDropdown } from './sort-dropdown';
import { SmartFilterCounter } from './smart-filter-counter';
import { FaFilter } from 'react-icons/fa';

function IconButtons(props) {
  const [filtersOpen, setFiltersOpen] = useState(false);

  const filterButtonRef = useRef(null);

  const {
    observedViolationTypes,
    observedPlatforms,
    platformIcons,
    strComplaintsAvailable,
    setSingleFilterParam,
    userToggledSort,
    sortApplied,
    currentCity,
    setCurrentPage,
  } = props;

  const availableViolationTypes = useMemo(
    () => Array.from(observedViolationTypes),
    [observedViolationTypes]
  );

  const availablePlatforms = useMemo(
    () => Array.from(observedPlatforms),
    [observedPlatforms]
  );

  return (
    <header.IconButtonParentWrapper>
      <CardFilterPopover
        availableViolations={availableViolationTypes}
        availablePlatforms={availablePlatforms}
        platformIcons={platformIcons}
        strComplaintsAvailable={strComplaintsAvailable}
        filterButtonRef={filterButtonRef}
        setFiltersOpen={setFiltersOpen}
        setSingleFilterParam={setSingleFilterParam}
        currentCity={currentCity}
        setCurrentPage={setCurrentPage}
      >
        <div style={{ marginRight: '10px' }}>
          <IconButtonWithTitle
            title="Filters"
            filterButtonRef={filterButtonRef}
            isActive={filtersOpen}
            // @ts-ignore IconButtonWithTitle is not typed
            icon={<FaFilter />}
            filterCount={props.filterCount}
          />
        </div>
      </CardFilterPopover>
      <SortDropdown
        userToggledSort={userToggledSort}
        sortApplied={sortApplied}
      />
    </header.IconButtonParentWrapper>
  );
}

export interface CardViewerHeaderComponentProps {
  observedViolationTypes: unknown;
  observedPlatforms: unknown;
  platformIcons: unknown;
  strComplaintsAvailable: unknown;
  setSingleFilterParam: unknown;
  userToggledSort: unknown;
  sortApplied: unknown;
  currentCity: unknown;
  filterCount: unknown;
  setCurrentPage: unknown;
}

function CardViewerHeaderComponent(props: CardViewerHeaderComponentProps) {
  const {
    observedViolationTypes,
    observedPlatforms,
    platformIcons,
    strComplaintsAvailable,
    setSingleFilterParam,
    userToggledSort,
    sortApplied,
    currentCity,
    filterCount,
    setCurrentPage,
  } = props;

  return (
    <header.HeaderWrapper>
      <header.TopWrapper>
        <SmartFilterCounter />
      </header.TopWrapper>

      <header.BottomWrapper>
        <IconButtons
          observedViolationTypes={observedViolationTypes}
          observedPlatforms={observedPlatforms}
          platformIcons={platformIcons}
          strComplaintsAvailable={strComplaintsAvailable}
          setSingleFilterParam={setSingleFilterParam}
          userToggledSort={userToggledSort}
          sortApplied={sortApplied}
          currentCity={currentCity}
          filterCount={filterCount}
          setCurrentPage={setCurrentPage}
        />
      </header.BottomWrapper>
    </header.HeaderWrapper>
  );
}

function mapStateToProps(state) {
  return {
    mapFilterParams: mapSelectors.mapFilterParams(state),
    currentCity: userSelectors.currentCity(state),
    filterCount: mapSelectors.filterCount(state),
    observedViolationTypes: dataSelectors.observedViolationTypes(state),
    observedPlatforms: dataSelectors.observedPlatforms(state),
    platformIcons: dataSelectors.platformIcons(state),
    strComplaintsAvailable: dataSelectors.strComplaintsAvailable(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setFilterParams: (mapFilterParams) =>
      dispatch(mapActions.setFilterParams({ mapFilterParams })),
    setSingleFilterParam: (change) =>
      dispatch(mapActions.setSingleFilterParam(change)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CardViewerHeaderComponent);
